import request from '@/utils/request.js'

// 通过阶段id查看课题阶段课题列表
export const getTopicListByTopicPhaseId = (data) => {
	return request({
		url:'/api/eduProjectManagement/phaseList',
		method:'post',
		data
	})
}

// 所有的课题管理列表数据
export const getAllTopicList = (data) => {
	return request({
		url:'/api/eduProjectManagement/allPhaseList',
		method:'post',
		data
	})
}

// 往该阶段中添加课题
export const addTopicToCurrentPhase = (data) => {
	return request({
		url:'/api/eduProjectManagement/addPhase',
		method:'post',
		data
	})
}

// 该阶段中删除课题
export const delTopicOnCurrentPhase = (id) => {
	return request({
		url:'/api/eduProjectManagement/delPhase/'+id,
		method:'get',
	})
}

// 获取在研课题列表
export const getUnderStudyTopicList = (data) => {
	return request({
		url:'/api/eduSummarizeResearchTopics/list',
		method:'post',
		data
	})
}

// 创建或者修改在研课题
export const createOrEditUnderStudyTopic = (data) => {
	return request({
		url:'/api/eduSummarizeResearchTopics/commit',
		method:'post',
		data
	})
}

// 删除在研课题
export const delUnderStudyTopic = (id) => {
	return request({
		url:'/api/eduSummarizeResearchTopics/del/'+id,
		method:'get',
	})
}

// 在研课题汇总的数据统计
export const underStudyTopicStat = () => {
	return request({
		url:'/api/eduSummarizeResearchTopics/text',
		method:'get',
	})
}


// 跳转到某一个流程阶段
export const jumpProcess = (data) => {
	return request({
		url:'/api/eduSummarizeResearchTopics/jumpNode',
		method:'post',
		data
	})
}

// 
export const getEduProjectId = (id) => {
	return request({
		url: `/api/eduProject/info/${id}`,
		method: 'get',
	})
}

// 负责的课题------------------------------------------------------------------------

// 根据当前登录人获取负责的课题列表
export const getTopicListByUser = (data) => {
	return request({
		url:'/api/eduProjectManagement/topicInChargeList',
		method:'post',
		data
	})
}

// 通过阶段类型和数据id查看上传报告
export const viewReportBystatusAndId = (data) => {
	return request({
		url:`/api/eduProjectManagement/getUploadReportInfo/${data.status}/${data.id}`,
		method:'get'
	})
}


// 上传或修改报告
export const uploadOrEditReport = (data) => {
	return request({
		url:'/api/eduProjectManagement/uploadReport',
		method:'post',
		data
	})
}

//过程材料列表
export const getProcessMaterialList = (data) => {
	return request({
		url:'/api/eduProjectManagement/resourcesList',
		method:'post',
		data
	})
}

// 上传或修改过程材料
export const uploadOrEditProcessMaterial = (data) => {
	return request({
		url:'/api/eduProjectManagement/uploadResources',
		method:'post',
		data
	})
}

// 删除过程材料
export const delProcessMaterial = (id) => {
	return request({
		url:`/api/eduProjectManagement/delResources/${id}`,
		method:'get'
	})
}

// 获取各个审核阶段的校审核或者区域审核的意见
export const getOpinionByPhaseIdAndAuditType = (data) => {
	return request({
		url:`/api/projectManagementAudit/auditList`,
		method:'post',
		data
	})
}

// 通过课题ID获取课题变更申请列表
export const getTopicChangeRecord = (id) => {
	return request({
		url:`/api/eduManagementAlteration/list/${id}`,
		method:'get',
	})
}

// 通过课题变更id删除课题变更记录
export const delTopicChangeRecordById = (id) => {
	return request({
		url:`/api/eduManagementAlteration/delAlteration/${id}`,
		method:'get',
	})
}

// 添加或者修改课题变更数据
export const addOrEditTopicChangeRecord = (data) => {
	return request({
		url:`/api/eduManagementAlteration/commit`,
		method:'post',
		data
	})
}

// 导出不同课题的过程材料
export const exportProcessMaterials = (id) => {
	return request({
		url:`/api/eduProjectManagement/resourcesZip/${id}`,
		method:'get',
		responseType:'blob',
	})
}


// 课题变更审核---------------------------------------------------------------------------------

// 课题变更审核列表
export const getTopicChangeRecordReviewList = (data) => {
	return request({
		url:`/api/eduManagementAlteration/auditList`,
		method:'post',
		data
	})
}

// 通过变更记录ID获取审查详情
export const getReviewDetailById = (id) => {
	return request({
		url:`/api/eduManagementAlteration/auditInfo/${id}`,
		method:'get',
	})
}

// 进行校审核或者区审核
export const schoolReviewOrAreaReview = (data) => {
	return request({
		url:`/api/eduManagementAlteration/audit`,
		method:'post',
		data
	})
}






// 课题审核----------------------------------------------------

//各个阶段的审核列表
export const reviewList = (data) => {
	return request({
		url:`/api/projectManagementAudit/list`,
		method:'post',
		data
	})
}

//根据课程管理id和审查类型获取课程管理详情
export const topicDetailByIdAndReviewType = (params) => {
	return request({
		url:`/api/projectManagementAudit/getManagementIdByManagementInfo/${params.id}/${params.type}`,
		method:'get'
	})
}

//校审核或者区审核
export const topicManageReview = (data) => {
	return request({
		url:`/api/projectManagementAudit/audit`,
		method:'post',
		data
	})
}

// 根据审核阶段获取区级审核列表上方的统计
export const getReviewPhaseStat = (type) => {
	return request({
		url:`/api/projectManagementAudit/getCountInfo/${type}`,
		method:'get',
	})
}

// 获取各个阶段的报告附件
export const getReportFile = (type) => {
	return request({
		url:`/api/projectManagementAudit/exportAttachmentReport/${type}`,
		method:'get',
		responseType:'blob',
	})
}




// 课题管理专家评审---------------------------------------------------------------------------

// 评审结果列表导出
export const expertReviewResultList = (settingId) => {
	return request({
		url:`/api/projectManagementSetting/excel/${settingId}`,
		method:'get',
		responseType: 'blob',
	})
}

// 专家评审设置列表
export const getExpertReviewList = (data) => {
	return request({
		url:`/api/projectManagementSetting/list`,
		method:'post',
		data
	})
}

// 获取专家基本信息设置详情
export const getBaseInfoDetail = (id) => {
	return request({
		url:`/api/projectManagementSetting/setting/${id}`,
		method:'get',
	})
}

// 
export const getBaseInfoDetail2 = (id) => {
	return request({
		url: `/api/projectManagementSetting/groupList/${id}`,
		method: 'get',
	})
}
// 添加或者修改专家基本设置
export const addOrEditBaseInfoDetail = (data) => {
	return request({
		url:`/api/projectManagementSetting/commit`,
		method:'post',
		data
	})
}

// 删除专家基本设置
export const delExpertReview = (id) => {
	return request({
		url:`/api/projectManagementSetting/del/${id}`,
		method:'delete'
	})
}

// 专用修改专家评审设置第一步
export const editExpertReviewBaseInfo = (data) => {
	return request({
		url:`/api/projectManagementSetting/updateBasicInfoOne`,
		method:'post',
		data
	})
}

// 保存课题分组
export const saveTopicGroup = (data) => {
	return request({
		url:`/api/projectManagementSetting/saveGroup`,
		method:'post',
		data
	})
}

// 删除分组
export const delTopicGroupById = (id) => {
	return request({
		url:`/api/projectManagementSetting/delGroupInfo/${id}`,
		method:'delete',
	})
}
// 移除课题
export const moveSubjectDeclare = (data) => {
	return request({
		url:`/api/projectManagementSetting/moveSubjectDeclare`,
		method:'post',
		data
	})
}

// 获取专家设置分组信息通过评审设置ID
export const getExpertReviewGroupListByReviewId = (id) => {
	return request({
		url:`/api/projectManagementSetting/groupList/${id}`,
		method:'get',
	})
}

// 初评或复评或终评添加课题管理列表
export const getTopicManagementList = (data) => {
	return request({
		url:`/api/projectManagementSetting/auditManagementList`,
		method:'post',
		data
	})
}

// 保存已经分配好的专家
export const saveAllocationExpert = (data) => {
	return request({
		url:`/api/projectManagementSetting/expertAllocation`,
		method:'post',
		data
	})
}

// 通过评审ID获取评分标准列表
export const getScoringList = (id) => {
	return request({
		url:`/api/projectManagementSetting/managementScoringCriteriaList/${id}`,
		method:'get',
	})
}

// 设置评分标准
export const saveScoring = (data) => {
	return request({
		url:`/api/projectManagementSetting/saveScoringCriteria`,
		method:'post',
		data
	})
}

// 根据评分标准ID删除评分标准
export const delScoringById = (id) => {
	return request({
		url:`/api/projectManagementSetting/delManagementScoringCriteria/${id}`,
		method:'delete',
	})
}

// 根据评分标准ID查看评审进度
export const getReviewProgress = (data) => {
	return request({
		url:`/api/projectManagementSetting/reviewProgressList`,
		method:'post',
		data
	})
}

// 根据评分标准ID查看评审进度2
export const getReviewProgressList = (data) => {
	return request({
		url: `/api/projectManagementSetting/reviewProgressList1`,
		method: 'post',
		data
	})
}


// 根据评分标准ID查看评审结果
export const getReviewResult = (data) => {
	return request({
		url:`/api/projectManagementSetting/reviewResultList`,
		method:'post',
		data
	})
}

// 根据评审ID和专家ID获取专家评审详情
export const getExpertReviewDetail = (params) => {
	return request({
		url:`/api/projectManagementSetting/reviewProgressInfo/${params.expertId}/${params.reviewId}`,
		method:'get',
	})
}

// 课题晋级功能
export const promotionFunction = (data) => {
	return request({
		url:`/api/projectManagementSetting/promotion`,
		method:'post',
		data
	})
}

// 提交评审结果
export const submitReviewResult = (data) => {
	return request({
		url:`/api/projectManagementSetting/submitReview`,
		method:'post',
		data
	})
}

// 根据评审ID和课题ID获取当前课题的评语列表
export const getRemarkListById = (params) => {
	return request({
		url:`/api/projectManagementSetting/projectManageInfo/${params.settingId}/${params.projectManagementId}`,
		method:'get',
	})
}

// 拟结题-----------------------------------------------------------


// 拟结题列表
export const getProposedClosingList = (data) => {
	return request({
		url:`/api/eduManagementConcluding/managementQuasiConcludingList`,
		method:'post',
		data
	})
}


// 拟结题-批准结题、不许结题、退回修改功能
export const concludingFunction = (data) => {
	return request({
		url:`/api/eduManagementConcluding/audit`,
		method:'post',
		data
	})
}

// 已结题------------------------------------------------------------------------------

// 已结题列表
export const getFinishedList = (data) => {
	return request({
		url:`/api/eduManagementConcluding/managementHasConcludingList`,
		method:'post',
		data
	})
}

// 设置结题证书编号前缀
export const setTheCertificateLabel = (data) => {
	return request({
		url:`/api/eduManagementConcluding/settingCertificateNumberPrefix`,
		method:'post',
		data
	})
}



// 专家评分------------------------------------------------------------------------

// 当前登录人是否有初评复评终评资格
export const getReviewAuthByUser = () => {
	return request({
		url:`/api/eduManagementExpertsScore/getProjectIdByQualification`,
		method:'get',
	})
}

// 评审列表
export const getReviewList = (data) => {
	return request({
		url:`/api/eduManagementExpertsScore/expertsScoreList`,
		method:'post',
		data
	})
}

// 评审课题列表
export const getReviewTopicList = (data) => {
	return request({
		url:`/api/eduManagementExpertsScore/auditList`,
		method:'post',
		data
	})
}


// 通过课程管理id,设置id,和评分id查看专家课程详情
export const getReviewTopicDeatil = (params) => {
	return request({
		url:`/api/eduManagementExpertsScore/getDeclareInfoByGroupIdAndDeclareId/${params.settingId}/${params.projectManagementId}/${params.expertsScoreId}`,
		method:'get',
	})
}


// 保存或者修改专家评分
export const saveOrEditExpertScore = (data) => {
	return request({
		url:`/api/eduManagementExpertsScore/saveOrUpdateExpertsScore`,
		method:'post',
		data
	})
}


// 专家提交评审
export const submitReview = (settingId) => {
	return request({
		url:`/api/eduManagementExpertsScore/submitExpertsReview/${settingId}`,
		method:'get',
	})
}


// 课题统计-----------------------------------------------------------------------------

// 课题类别统计
export const topicTypeStat = () => {
	return request({
		url:`/api/projectManagementCount/projectTypeCount`,
		method:'get',
	})
}

// 课题领域统计
export const topicDomainStat = () => {
	return request({
		url:`/api/projectManagementCount/researchFieldCount`,
		method:'get',
	})
}

// 课题学段统计
export const topicStudyPhaseStat = () => {
	return request({
		url:`/api/projectManagementCount/learningTypeCount`,
		method:'get',
	})
}

// 课题研究阶段统计
export const topicResearchPhaseStat = () => {
	return request({
		url:`/api/projectManagementCount/researchFieldPhaseCount`,
		method:'get',
	})
}

// 按学科统计
export const disciplineStat = () => {
	return request({
		url:`/api/projectManagementCount/disciplineCount`,
		method:'get',
	})
}


// 按学校统计
export const schoolStat = () => {
	return request({
		url:`/api/projectManagementCount/schoolCount`,
		method:'get',
	})
}




// 获取课题类别课题列表
export const getTopicTypeTable = () => {
	return request({
		url:`/api/projectManagementCount/projectTypeCountList`,
		method:'get',
	})
}

// 课题领域列表
export const getTopicDomainTable = () => {
	return request({
		url:`/api/projectManagementCount/researchFieldCountList`,
		method:'get',
	})
}

// 课题研究阶段列表
export const getResearchPhaseTable = () => {
	return request({
		url:`/api/projectManagementCount/researchFieldPhaseCountList`,
		method:'get',
	})
}


// 学段列表
export const getStudyPhaseTable = () => {
	return request({
		url:`/api/projectManagementCount/learningTypeCountList`,
		method:'get',
	})
}

// 学科列表
export const getDisciplineTable = () => {
	return request({
		url:`/api/projectManagementCount/disciplineCountList`,
		method:'get',
	})
}


// 学校列表
export const getSchoolTable = (name="") => {
	return request({
		url:'/api/projectManagementCount/schoolCountList?name='+name,
		method:'get',
	})
}

//取消评分
export const cancleCommitScore = (userId, settingId) => {
	return request({
		url:'/api/projectManagementSetting/cancelScoringCriteria/'+userId+'/'+settingId,
		method:'get',
	})
}


//上传评分标准附件
export const uploadScoringCriteriaAnnex = (groupId, annexId) => {
  return request({
    url:'/api/projectManagementSetting/uploadScoringCriteriaAnnex/'+groupId+'/'+annexId,
    method:'get'
  });
}
// 用户负责学段列表
export const  getUserLearningSection= () => {
	return request({
	  url:'/api/eduLearningSection/getUserLearningSection',
	  method:'get'
	});
  }


export const uploadToLocal = (data)=>{
  return request({
    url : '/upload/uploadToLocal',
    method:'post',
    data
  })
}










